// extracted by mini-css-extract-plugin
module.exports = {"list":"benefits-block-module--list--29YnV","listLink":"benefits-block-module--listLink--1ePWV","listLinkActive":"benefits-block-module--listLinkActive--1AXcr"};